import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';

const CareerMain = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedJobId, setExpandedJobId] = useState(null);

  // ⭐ JobCard Component MUST be at the top
  const JobCard = ({ job, expandedJobId, toggleJob }) => (
    <div
      className="card border-0 shadow-sm rounded-4 bg-white job-card"
      style={{ transition: 'transform 0.3s ease', cursor: 'pointer' }}
    >
      <div
        className="card-header bg-transparent border-bottom-0 p-4 d-flex justify-content-between align-items-center"
        onClick={() => toggleJob(job.id)}
      >
        <h5 className="mb-0 fw-semibold text-primary">{job.title}</h5>
        <span className="fs-4 text-muted">
          {expandedJobId === job.id ? "−" : "+"}
        </span>
      </div>

      <div
        className={`card-body px-4 pt-0 pb-4 ${
          expandedJobId === job.id ? "show" : "collapse"
        }`}
        style={{
          maxHeight: expandedJobId === job.id ? "600px" : "0",
          overflow: "hidden",
          transition: "max-height 0.4s ease",
        }}
      >
        <hr className="my-3" />
        <p className="text-secondary">{job.description}</p>
        <p className="text-muted small mb-1">
          <strong>Location:</strong> {job.location}
        </p>
        <p className="text-muted small mb-1">
          <strong>Posted on:</strong> {job.posted_date}
        </p>
        <p className="text-muted small mb-3">
          <strong>Deadline:</strong> {job.deadline}
        </p>

        {job.pdf_filename && (
          <a
            href={`/assets/job_pdfs/${job.pdf_filename}`}
            download={`${job.title.replace(/[^a-z0-9]/gi, "_")}.pdf`}
            className="btn btn-primary rounded-pill px-4 py-2"
          >
            📥 Download Job Details (PDF)
          </a>
        )}
      </div>
    </div>
  );

  // ⭐ Manually added jobs
  const manualJobs = [
    {
      id: "m1",
      title: "Janitorial & Security Jobs",
      description:
        "Responsible for maintaining cleanliness of premises, supporting security operations, and assisting in daily facility tasks.",
      location: "Rawalpindi",
      posted_date: "2025-11-18",
      deadline: "2025-11-22",
      pdf_filename: "janitorial_security_details.pdf", // ADD YOUR PDF NAME HERE
    },
  ];

  // ⭐ Fetching jobs from API
  useEffect(() => {
    fetch("https://ricgop.online/api/jobs.php")
      .then((res) => res.json())
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
        setLoading(false);
      });
  }, []);

  const toggleJob = (id) => {
    setExpandedJobId((prev) => (prev === id ? null : id));
  };

  // ⭐ Render job categories from API
  const renderJobsByCategory = (category, displayName, icon) => {
    const filtered = jobs.filter((j) => j.category === category);
    if (filtered.length === 0) return null;

    return (
      <>
        <h3 className="text-dark fw-bold mb-4 mt-5">
          {icon} {displayName}
        </h3>
        <div className="row justify-content-center">
          {filtered.map((job) => (
            <div className="col-md-10 col-lg-8 mb-4" key={job.id}>
              <JobCard
                job={job}
                expandedJobId={expandedJobId}
                toggleJob={toggleJob}
              />
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <main>
      <Breadcrumb title="Career Opportunities" />

      <section className="py-5" style={{ backgroundColor: "#f9fbfc" }}>
        <div className="container">
          <h2 className="text-center mb-5 text-dark fw-bold display-5">
            💼 Current Job Openings
          </h2>

          {loading ? (
            <p className="text-center text-secondary">Loading jobs...</p>
          ) : (
            <>
              {renderJobsByCategory("Technical", "Technical Jobs", "🛠️")}
              {renderJobsByCategory(
                "Administrative",
                "Administrative Jobs",
                "📋"
              )}
              {renderJobsByCategory("General", "General Vacancies", "👥")}
            </>
          )}

          {/* ⭐ Manual Jobs Section */}
          <h3 className="text-dark fw-bold mb-4 mt-5">📌 New Open Vacancies</h3>
          <div className="row justify-content-center">
            {manualJobs.map((job) => (
              <div key={job.id} className="col-md-10 col-lg-8 mb-4">
                <JobCard
                  job={job}
                  expandedJobId={expandedJobId}
                  toggleJob={toggleJob}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CareerMain;
